export interface History {
  phase: CurrentPhaseMovedToPhasesProps;
}

export interface Field {
  name: string;
  value?: string;
  id?: string;
}

export interface Card {
  phases_history: History[];
  fields: Field[];
}

export interface FormPipefyProps {
  card: Card;
}

export interface StateInputProps {
  [key: string]: string;
}

export enum InputsHide {
  LOTE = "lote",
  DATA_VALIDADE = "data_de_validade",
  DATA_FABRICACAO = "data_de_fabrica_o",
  DATA_OCORRENCIA_1 = "data_da_ocorr_ncia_1",
  CARGO = "cargo",
  HA_SALDO_REMANESCENTE = "h_saldo_remanescente_no_estoque_do_lote_reclamado",
  TIPO_OCORRENCIA = "tipo_de_ocorr_ncia",
  ESPECIFICACAO_TIPO_OCORRENCIA = "especifica_o_do_tipo_de_ocorr_ncia",
  DESCRICAO_QUEIXA = "descri_o_detalhada_da_queixa_t_cnica",
  AMOSTRA_CONTAMINADA_DISPONIVEL = "amostra_n_o_contaminada_do_produto_dispon_vel_para_coleta",
  TIPO_AMOSTRA = "tipo_de_amostra",
  QTD_RECLAMADA = "quantidade_reclamada",
  STATUS_INTEGRACAO_DEVOLUCAO = "status_integra_o_de_devolu_o",
  PROBLEMAS_NO_ENVIO_DE_EMAIL = "problemas_no_envio_de_e_mail",
  VALOR_DO_DESCONTO = 'valor_do_desconto'
}

export const reasonsShowSefaz = [
  "CARTA DE CORREÇÃO",
  "CONFIRMAÇÃO DE ENDEREÇO DE ENTREGA"
];

export const phasesBuCardPipefy = [
  'Análise do protocolo',
  'Aceite da solicitação',
  'Avaliação Torre de Controle'
];

export interface CardProps {
  comments_count: number;
  done: boolean;
  current_phase: CardFieldsCurrentPhaseProps;
  fields: Array<FieldsCardProps>;
  phases_history: Array<PhasesHistoryProps>;
}

export interface CardFieldsCurrentPhaseProps {
  cards_can_be_moved_to_phases: Array<CurrentPhaseMovedToPhasesProps>;
  fields: Array<FieldsCurrentPhaseProps>;
  id: string;
  name: string;
  sequentialId: string;
  __typename: string;

}

export interface FieldsCurrentPhaseProps {
  description: string;
  help: string;
  id: string;
  label: string;
  options: string[];
  required: boolean;
  type: string;
  __typename: string;
}

export interface FieldsCardProps {
  name: string;
  value: string;
  field: Omit<FieldsCurrentPhaseProps, "help" | "label" | "required">;
}

export interface PhasesHistoryProps {
  became_late?: boolean;
  created_at?: string;
  duration?: number;
  firstTimeIn?: string;
  lastTimeIn?: string;
  lastTimeOut?: string;
  phase?: {
    name?: string;
    fields?: PhasesHistoryFieldsProps[];
  };
}

export interface CurrentPhaseMovedToPhasesProps {
  id: string;
  name: string;
  order: number;
  sequentialId: string;
  __typename: string;
}

export interface PhasesHistoryFieldsProps {
  id: string;
  label: string;
  synced_with_card: boolean;
  type: string;
  __typename: string;
}
